<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div>
    <div v-for="option in extraOptions"
         class="ui checkbox">
      <input :checked="!isEditable"
             :data-option-id="option.ID"
             :onclick="`return ${isEditable}`"
             :readonly="!isEditable"
             type="checkbox">
      <label>{{ option.name }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extraOptions: Array,
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.ui.checkbox {
  padding: 0.2rem 0.3rem;
}
</style>
